import { useState, useEffect } from "react";
import Header from "./Header";
import { CircularProgress, Box, Typography } from "@mui/material";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import createAssessmentApi from "./fetchApi/createAssessmentApi";
import CustomErrorDialogBox from "./components/CustomErrorDialogBox/CustomErrorDialogBox";
import { useTranslationSetup } from "./utils/useTranslationSetup.js";
import { UrlConstants } from "./utils/CommonUtils/constants.js";
import girlHoldingPhoneHi from "./assets/girl_holding_phone_hi_letter.svg";
import girlHoldingPhoneEn from "./assets/girl_holding_phone_en_letter.svg";
import girlHoldingPhoneGu from "./assets/girl_holding_phone_gu_letter.svg";
import sendFeedback from "./fetchApi/sendFeedback.js";
import { SCREENS } from "./utils/CommonUtils/screenConstants.js";
import "./EnterOrfApplicationLoadingScreen.css";

const EnterOrfApplicationLoadingScreen = ({
  setParaData,
  studentName,
  setAssessmentLang,
  organisation,
  requestBody,
  setFeedbackResponse,
  feedbackData,
  assessmentLang,
  setActiveScreen,
}) => {
  const [assessmentCreatingStatus, setAssessmentCreatingStatus] =
    useState(null);
  const [openDialogForError, setOpenDialogForError] = useState(false);
  const { t } = useTranslationSetup();

  useEffect(() => {
    const createAssessment = async () => {
      try {
        const response = await createAssessmentApi(
          `${UrlConstants.BASE_URL}${UrlConstants.BASE_PATH_URL}${UrlConstants.ASSESSMENT}`,
          requestBody
        );

        if (response.status === "ERROR") {
          handleAssessmentError();
        } else {
          handleAssessmentSuccess(response);
        }
      } catch (error) {
        handleAssessmentError("ERR_INTERNET_DISCONNECTED");
      }
    };

    const handleAssessmentSuccess = (response) => {
      setParaData(response);
      if (organisation === "pratham_demo_1") {
        const feedbackUrl = `${UrlConstants.BASE_URL}${UrlConstants.BASE_PATH_URL}${UrlConstants.ASSESSMENT}/${response.id}/feedback`;
        sendFeedbackData(feedbackUrl);
      }
    };

    const sendFeedbackData = async (feedbackUrl) => {
      try {
        const response = await sendFeedback(feedbackData, feedbackUrl);
        if (response.status === "ERROR") {
          handleAssessmentError(response.status);
        } else {
          setFeedbackResponse(response);
        }
      } catch (error) {
        handleAssessmentError("ERR_INTERNET_DISCONNECTED");
      }
    };

    const handleAssessmentError = (errorType = "ERROR") => {
      setOpenDialogForError(true);
      setAssessmentCreatingStatus(errorType);
    };

    const assessmentTimeout = setTimeout(createAssessment, 3000);

    return () => clearTimeout(assessmentTimeout);
  }, []);

  return (
    <>
      {(assessmentCreatingStatus === "ERROR" ||
        assessmentCreatingStatus === "ERR_INTERNET_DISCONNECTED") && (
        <CustomErrorDialogBox
          header={t("something_went_wrong")}
          icon={<ErrorOutlineOutlinedIcon className="error-box" />}
          secondaryButtonText={t("try_again")}
          isDialogOpen={openDialogForError}
          showPrimaryButton={false}
          showSecondaryButton={true}
          onClickSecondaryButton={() => {
            setOpenDialogForError(false);
            setActiveScreen(SCREENS.RENDER_ASSESSMENT_LANG_SCREEN);
            setAssessmentLang(null);
          }}
        />
      )}
      <Box className="orf-app-loading-screen-container">
        <Header
          heading={t("orf_assess")}
          background="linear-gradient(134.56deg, #E47714 59.55%, rgba(228, 119, 20, 0.4) 152.08%)"
          hideArrow={true}
        />

        <Box className="student-name-container">
          <Typography className="student-name-text">{studentName}</Typography>
        </Box>
        <Box className="image-container">
          <Typography className="language-assessment-text">{`${
            assessmentLang.label
          } ${t("assessment")}`}</Typography>
          <img
            className="girl-image"
            src={
              assessmentLang.value === "en"
                ? girlHoldingPhoneEn
                : assessmentLang.value === "gu"
                ? girlHoldingPhoneGu
                : girlHoldingPhoneHi
            }
            alt="welcome-logo"
          />
        </Box>
        <Box className="loading-container">
          <Typography className="loading-text">
            {t("loading")}
            <Box>
              <CircularProgress size="12px" background="black" />
            </Box>
          </Typography>
        </Box>
      </Box>
    </>
  );
};

export default EnterOrfApplicationLoadingScreen;
